import { useState } from 'react'
import { colors } from '@ui/colors'
import Dropdown from '@ui/elements/Dropdown'
import { DropdownItemProps } from '@ui/elements/Dropdown/types'
import GlassButton from '@ui/elements/Glass/GlassButton'
import ConfirmationModal from '@ui/components/ConfirmationModal'

import useDropdownStage from './useDropdownStage'
import { useAnimatedOpacity } from '@ui/animated/useAnimatedOpacity'

type Props = { items?: DropdownItemProps[] }

export default function DropdownTopbar(props: Props) {
  const [open, setOpen] = useState(false)
  const items = useDropdownStage()

  const hasItems = items.length > 0

  const styleOpacity = useAnimatedOpacity(!!hasItems)

  return (
    <>
      <GlassButton style={styleOpacity}>
        {hasItems && (
          <Dropdown
            open={open}
            setOpen={setOpen}
            popoverProps={{
              offset: 31,
            }}
            items={props.items ?? items}
            icon={{ name: 'dots', color: colors.black }}
          />
        )}
      </GlassButton>
      {items.map(
        ({ modal }, i) =>
          modal && (
            <ConfirmationModal
              key={i}
              open={modal.isOpen}
              onClose={modal.onClose}
              onConfirm={modal.onConfirm}
              title={modal.title}
              desc={modal.desc}
            />
          )
      )}
    </>
  )
}
